import { field, date, relation, writer, children,text } from '@nozbe/watermelondb/decorators';
import { SALE_ORDER_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class SaleOrder extends Model {
  static table = SALE_ORDER_SCHEMA;

  static associations = {
    customer: { type: 'belongs_to', key: 'customer_id' },
    business: { type: 'belongs_to', key: 'business_id' },
    sale_order_line: { type: 'has_many', foreignKey: 'sale_order_id' }
  }

  @text('discount_unit') discount_unit;
  @field('discount') discount;
  @text('tax_type') tax_type;
  @text('status') status;
  @text('note') note;
  @field('tax') tax;

  @date('created_at') created_at;

  @relation('customer', 'customer_id') customer;
  @relation('business', 'business_id') business;

  @children('sale_order_line') sale_order_line;

  @writer async updateSaleOrderStatus(status) {
    await this.update((saleOrder) => {
      saleOrder.status = status;
    });
  }

  @writer async updateSaleOrderNote(note) {
    await this.update((saleOrder) => {
      saleOrder.note = note;
    });
  }
  @writer async updateSaleOrderTax({ tax, tax_type = '%' }) {
    await this.update((saleOrder) => {
      saleOrder.tax = tax;
      saleOrder.tax_type = tax_type;
    });
  }
  @writer async updateSaleOrderDiscount({ discount, discount_unit = 'rs' }) {
    return await this.update((saleOrder) => {
      saleOrder.discount = discount;
      saleOrder.discount_unit = discount_unit;
    });
  }
  @writer async updateSaleOrderCustomer(customer) {
    return await this.update((saleOrder) => {
      saleOrder.customer.set(customer);
    });
  }
}